import React from "react";
import PlayBackHead from "./HistoryHead/PlayBackHead";
import PlayBackDate from "./HistoryHead/HistoryDate/PlayBackDate";

export default function PlayBackSelection({
	setStartDate,
	startDate,
	setEndDate,
	endDate,
	setVId,
	vid,
	media,
	setMedia,
}) {
	const lang = localStorage.getItem("lang") || "en";
	return (
		<div
			className={` p-0 ${
				lang === "en"
					? "history-playback-trip-date-ltr"
					: "history-playback-trip-date-rtl"
			} history-playback-date`}
		>
			<PlayBackHead />
			<div className="H-line"></div>
			<PlayBackDate
				setStartDate={setStartDate}
				startDate={startDate}
				setEndDate={setEndDate}
				endDate={endDate}
				setVId={setVId}
				vid={vid}
				media={media}
				setMedia={setMedia}
			/>
		</div>
	);
}
